module.exports = __webpack_public_path__ + "img/carpool_coupon_package_content_bg.1fa0f2b1.png";